module.exports = __webpack_public_path__ + "img/125.4.e17812b6.png";